import { render, staticRenderFns } from "./SelectFromItems.vue?vue&type=template&id=cd83acbc&"
import script from "./SelectFromItems.vue?vue&type=script&lang=js&"
export * from "./SelectFromItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports